import type { ProjectStatus, ProjectType } from "@/common/model";
import {
	createLabelTag,
	createStatusBadge,
	type TagStatus,
} from "../status-pill";

export const GraphTypeLabelMap: Record<string, string> = {
	DEFAULT: "Default",
	CLOUD_APPLICATION: "Cloud Application",
};

export const ProjectTypeLabelMap: Record<ProjectType, string> = {
	SOFTWARE_APPLICATION: "Software Application",
	OTHER: "Generic",
};

export const ProjectStatusColorMap: Record<ProjectStatus, TagStatus> = {
	ACTIVE: "success",
	ARCHIVED: "default",
};

export const ProjectStatusLabelMap: Record<ProjectStatus, string> = {
	ACTIVE: "Active",
	ARCHIVED: "Archived",
};

export const ProjectStatusBadge = createStatusBadge(
	ProjectStatusColorMap,
	ProjectStatusLabelMap,
);

export const ProjectTypeBadge = createLabelTag(ProjectTypeLabelMap);

export const GraphTypeBadge = createLabelTag(GraphTypeLabelMap);
